/**
 * Admin Telegram Migration API
 */

import type { z } from "zod";

import { ApiSuccessSchema } from "../../common/response.schema";
import type { InferSchemas } from "../../schema-inference";
import {
  MigrateTelegramWebhookBodySchema,
  MigrateTelegramWebhookResponseSchema,
  TelegramMigrationRecordSchema,
  TelegramMigrationStatusResponseSchema
} from "./schemas/telegram-migration.schemas";

export const ZAdminTelegramMigration = {
  GetStatus: {
    method: "GET" as const,
    path: "/api/admin/webhook-migration/telegram/status",
    Response: ApiSuccessSchema(TelegramMigrationStatusResponseSchema)
  },
  Migrate: {
    method: "POST" as const,
    path: "/api/admin/webhook-migration/telegram/migrate",
    Body: MigrateTelegramWebhookBodySchema,
    Response: ApiSuccessSchema(MigrateTelegramWebhookResponseSchema)
  }
} as const;

export type TApiAdminTelegramMigration = InferSchemas<typeof ZAdminTelegramMigration>;

// ============================================================
// Convenience Type Exports
// ============================================================

export type TelegramMigrationRecord = z.infer<typeof TelegramMigrationRecordSchema>;
export type TelegramMigrationStatusResponse = z.infer<typeof TelegramMigrationStatusResponseSchema>;
